import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
    containerMeasurementsFeatureKeys,
    ContainerMeasurementState,
} from './container-measurements.reducer';

export const selectContainerMeasurementsState = createFeatureSelector<ContainerMeasurementState>(
    containerMeasurementsFeatureKeys,
);

export const selectCachedContainerMeasurements = createSelector(
    selectContainerMeasurementsState,
    (state) => state.cachedContainerMeasurements,
);

export const selectCachedContainerMeasurementsAsArray = createSelector(
    selectCachedContainerMeasurements,
    (cachedContainerMeasurements) => Object.values(cachedContainerMeasurements),
);
